export default __webpack_public_path__ + "images/trash-alt_798e759bc12ed99e2de7ed1c53208219.svg";